'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    var selectionsListHolder = document.getElementById('selectionsListHolder');
    if (!selectionsListHolder) {
        return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/odata/SelectedCategory');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-XSRF-TOKEN', getCookie('XSRF-TOKEN'));
    xhr.onreadystatechange = function () {
        getSelectionsDone();
    };
    xhr.send();

    function getSelectionsDone() {
        try {
            if (!xhr || xhr.readyState !== 4) return;

            var returnedObject = JSON.parse(xhr.response);
            var template = document.getElementById('selectionRowTemplate');

            var selectionArray = returnedObject.value.filter(function (f) {
                return !f.isDeleted && f.isActive;
            }).sort(function (a, b) {
                return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
            });

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var selection = _step.value;


                    var selectionRow = template.content.cloneNode(true);
                    var chbSelection = selectionRow.querySelector('input.chbselectionrow');
                    chbSelection.checked = getSelectionsFromInput().some(function (s) {
                        return s === selection.id.toString();
                    });
                    chbSelection.dataset.id = selection.id;
                    chbSelection.addEventListener('click', checkboxChange);
                    selectionRow.querySelector('div.selectionrowtext').textContent = selection.name;
                    selectionRow.querySelector('div.datecreated').textContent = new Date(selection.creationTime).toLocaleString();
                    selectionsListHolder.appendChild(selectionRow);
                };

                for (var _iterator = selectionArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } catch (e) {
            toastr.error(Resx.Messages.ErrorTitle, Resx.Messages.ErrorTitle);
            console.error(e);
        }
    }

    function getSelectedCategoriesElement() {
        return document.getElementById('Section_SelectedCategoriesIdsString');
    }

    function getSelectionsFromInput() {
        var selectedCategoriesElement = getSelectedCategoriesElement();
        return selectedCategoriesElement.value.match(/[0-9]+/g) || [];
    }

    function checkboxChange(event) {
        var selectedCategoriesElement = getSelectedCategoriesElement();
        var selectionArray = getSelectionsFromInput();

        var selectionIndex = selectionArray.indexOf(event.target.dataset.id);
        if (selectionIndex > -1 && !event.target.checked) {
            selectionArray.splice(selectionIndex, 1);
        } else if (selectionIndex < 0 && event.target.checked) {
            selectionArray.push(event.target.dataset.id);
        }

        selectedCategoriesElement.value = selectionArray.join('|');
    }
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/selectionList.js
// module id = 453
// module chunks = 0